import React, { Fragment, ReactElement } from "react";
import { DateBox } from "./InputBoxes";
import { parseISO } from "date-fns/esm";

interface IDateInputListProps {
  onChange: (selectedValue: Date) => void;
  value?: string;
}

export const DateInputList = (props: IDateInputListProps): ReactElement => {
  const selectedDate = props.value ? parseISO(props.value) : null;
  return (
    <Fragment>
      <DateBox onChange={props.onChange} value={selectedDate} />
    </Fragment>
  );
};
